// extracted by mini-css-extract-plugin
export var divider = "_yh-0";